import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Menu from "../components/shops/Menu.js";
import Footer from "../components/shops/Footer.js";
import WebDemo from "../components/shops/WebDemo.js";

const ShopDemo = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.shopDemo.title")}</title>
				<meta name="description" content={t("seo.shopDemo.description")} />
				<link rel="canonical" href="https://applaby.com/tiendas/demo" />
			</Helmet>

			<Menu />
			<WebDemo />
			<Footer />
		</>
	);
};

export default ShopDemo;
